import { BasicService } from "./core/basic.service";
import moment from "moment";

export class GoodsService extends BasicService {

  // 保存编辑
  static async save(form1, form2, form3) {
    const formData1 = Object.assign({}, form1);
    // !formData1.is_healthcare && delete formData1.healthcare_type
    !formData1.is_free_shipping && delete formData1.shipping_fee;
    await this.extractImg(formData1, 'original_img')
    await this.extractImg(formData1, 'images', true);
    const data = { ...formData1, ...form2 };
    if (data.shelf_life) {
      data.shelf_life[0] = moment(form2.shelf_life[0]).format('YYYY-MM-DD HH:mm:ss');
      data.shelf_life[1] = moment(form2.shelf_life[1]).format('YYYY-MM-DD HH:mm:ss');
      data.shelf_life = data.shelf_life.join(',');
    }
    delete data.certificates;
    const goods_id = await this.http.post('/goods/save', data);
    if (form3) {
      form3.goods_id = goods_id;
      await this.certificateSave(form3);
    }
  }

  static getMenu() {
    return this.http.post('/goods/goodsBaseData');
  }

  static async certificateSave(data) {
    const imgs = Object.assign({}, data);
    const reqList = [];
    for(let key of Object.keys(imgs)) {
      if (imgs[key] instanceof Array) {
        reqList.push(this.extractImg(imgs, key));
      }
    }
    await Promise.all(reqList);
    imgs.expiration_date = moment(imgs.expiration_date).format('YYYY-MM-DD');
    return this.http.post('/goods/goodsCertificatesSave', imgs);
  }

  static delete(goods_ids) {
    return this.http.post('/goods/delGoods', { goods_ids });
  }
  // 获取商品批号
  static getBatchNumber(goods_id, data) {
    return this.http.post('/goods/goodsCertificates', { goods_id, ...data })
  }

  static async saveBatchNumber(data, type) {
    const formData1 = Object.assign({}, data);
    await this.extractImg(formData1, 'img')
    formData1.expiration_date = moment(formData1.expiration_date).format('YYYY-MM-DD');
    return this.http.post(type === 'add' ? '/goods/goodsBatchSave' : '/goods/goodsBatchEdit', formData1)
  }

  static delBatchNumber(batch_id) {
    return this.http.post('/goods/goodsBatchDel', { batch_id });
  }

  static detail (goods_id) {
    return this.http.post('/goods/goodsList', { goods_id });
  }

  static getList(data) {
    return this.http.post('/goods/goodsList', data)
  }

  static categoryList() {
    return this.http.post('/goods/categoryList');

  }

  static brandList(data) {
    return this.http.post('/Goods/brandList', data)
  }

  static brandChangeStatus(id, tag, state) {
    return this.http.post('/goods/brandStateSwitch', { id, tag, state });
  }

  static categoryChangeStatus(id, tag, state) {
    return this.http.post('/goods/categoryStateSwitch', { id, tag, state });
  }

  static changeGoodsStatus(goods_id, state_name) {
    return this.http.post('/goods/goodsStateSwitch', {  state_name, goods_id})
  }
}